import { useAppContext } from '../../../context/AppContext';
import { updateData, fetchData } from '../../../services';
import { useState } from 'react';
import Modal from '../../helpers/Modal';
const ADDON_ITEMS = [
    { name: 'Chain Hoist - Basic', sku: 'CHAIN-HOIST-BASIC' },
    { name: 'Lift Bracket & Safety Chain', sku: 'LIFT-BRACKET-SQUARE' },
];

export const UpdateAddonQuantityForm = ({ invoice, addon, onOpen, onClose, isOpen: controlledOpen, onClose: controlledOnClose }) => {
    const { token, base_url, setInvoices } = useAppContext();
    const [internalOpen, setInternalOpen] = useState(false);
    const [quantity, setQuantity] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [error, setError] = useState('');

    const isControlled = controlledOnClose != null;
    const isModalOpen = isControlled ? controlledOpen : internalOpen;

    const openModal = () => {
        setQuantity('');
        setError('');
        if (!isControlled) {
            setInternalOpen(true);
        }
        onOpen?.();
    };

    const closeModal = () => {
        if (isControlled) {
            controlledOnClose?.();
        } else {
            setInternalOpen(false);
        }
        onClose?.();
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        const qty = parseInt(quantity, 10);
        if (Number.isNaN(qty) || qty < 0) {
            setError('Please enter a valid quantity (0 or greater).');
            return;
        }

        setIsSubmitting(true);
        try {
            await updateData(token, `${base_url}/apis/billing/invoices/${invoice.id}`, {
                item: addon.sku,
                quantity: qty,
            });

            const invoicesData = await fetchData(token, `${base_url}/apis/billing/invoices`);
            if (invoicesData?.invoices) {
                setInvoices(invoicesData.invoices);
            }

            window.showAlert?.(200, `${addon.name} quantity updated successfully.`);
            closeModal();
        } catch (err) {
            console.error('Error updating addon quantity:', err);
            const status = err?.status ?? 500;
            if (status === 404) {
                window.showAlert?.(404, 'Invoice not found.');
            } else if (status >= 400 && status < 500) {
                setError('Invalid request. Please check the quantity and try again.');
            } else {
                window.showAlert?.(500, 'Failed to update quantity. Please try again.');
            }
        } finally {
            setIsSubmitting(false);
        }
    };

    const formContent = (
        <div>
            <h2>Update {addon.name} quantity</h2>
            <p>Invoice: <strong>{invoice.invoice_number}</strong></p>
            <form onSubmit={handleSubmit}>
                <div className="form-group">
                    <label htmlFor={`quantity-${addon.sku}`}>Quantity</label>
                    <div className="quantity-pill-selector">
                        <input
                            id={`quantity-${addon.sku}`}
                            type="number"
                            className="pill-qty-input"
                            min="0"
                            step="1"
                            value={quantity === '' ? '' : quantity}
                            onChange={(e) => {
                                const raw = e.target.value;
                                if (raw === '') {
                                    setQuantity('');
                                    return;
                                }
                                const value = parseInt(raw, 10) || 0;
                                setQuantity(String(Math.max(0, value)));
                            }}
                            placeholder="0"
                            disabled={isSubmitting}
                            autoFocus
                        />
                    </div>
                </div>
                {error && <p className="form-error">{error}</p>}
                <div className="form-actions">
                    <button
                        type="button"
                        onClick={closeModal}
                        className="btn btn-secondary"
                        disabled={isSubmitting}
                    >
                        Cancel
                    </button>
                    <button
                        type="submit"
                        className="btn btn-primary"
                        disabled={isSubmitting}
                    >
                        {isSubmitting ? 'Updating…' : 'Update quantity'}
                    </button>
                </div>
            </form>
        </div>
    );

    const setModalOpen = isControlled ? (open) => { if (!open) controlledOnClose?.(); } : setInternalOpen;

    return (
        <>
            {!isControlled && (
                <button
                    type="button"
                    className="btn btn-action btn-primary"
                    title={`Update ${addon.name} quantity`}
                    onClick={openModal}
                >
                    Update {addon.name} quantity
                </button>
            )}
            {isModalOpen && (
                <Modal form={formContent} setIsModalOpen={setModalOpen} />
            )}
        </>
    );
};

export { ADDON_ITEMS };
